import React, { Component } from 'react';
import FoodItem from './fooditem/FoodItem';
import FoodItemPage from './fooditem/FoodItemPage';
import './fooditem/FoodItem.css';

export default class FoodGallery extends Component {
  constructor(props) {
    super(props);
    this.state = { display: [] };
    this.displayPageClick = this.displayPageClick.bind(this);
  }

  componentDidUpdate() {
    let states = this.state.display.length;
    let props = this.props.foodItems.length;
    if (states !== props) {
      this.setState({ display: this.props.foodItems.map(() => false) });
    }
  }

  displayPageClick(index) {
    let newState = this.state.display.map((display, ind) =>
      ind === index ? !display : display
    );
    this.setState({ display: newState });
  }

  render() {
    return (
      <div style={galleryStyle}>
        {this.props.foodItems.map((item, ind) => (
          <FoodItem
            foodItem={item}
            key={item.id}
            index={ind}
            onClick={this.displayPageClick}
            filter={this.props.filter}
            search={this.props.search}
          />
        ))}
        {this.props.foodItems.map((item, index) => (
          <FoodItemPage
            foodItem={item}
            key={item.id}
            id={item.id}
            display={this.state.display[index]}
            changeItem={this.props.changeItem}
            onClick={this.displayPageClick}
            index={index}
            pass={this.props.pass}
          />
        ))}
      </div>
    );
  }
}

const galleryStyle = {
  maxWidth: '100%',
  display: 'flex',
  flexWrap: 'wrap'
};
